export const micrositeFonts = [
  {
    label: "Roboto",
    slug: "roboto-regular",
    family: "'Roboto', sans-serif",
    path: "Roboto:ital,wght@0,100..900;1,100..900",
  },
  {
    label: "Roboto Mono",
    slug: "roboto",
    family: "'Roboto Mono', monospace",
    path: "Roboto+Mono:ital,wght@0,100..700;1,100..700",
  },
  {
    label: "Roboto Slab",
    slug: "roboto-slab",
    family: "'Roboto Slab', serif",
    path: "Roboto+Slab:ital,wght@0,100..900;1,100..900",
  },
  {
    label: "Rozha One",
    slug: "rozha-one",
    family: "'Rozha One', serif",
    path: "Rozha+One",
  },
  {
    label: "Archivo Black",
    slug: "archivo-black",
    family: "'Archivo Black', sans-serif",
    path: "Archivo+Black",
  },
  {
    label: "Poppins",
    slug: "poppins",
    family: "'Poppins', sans-serif",
    path: "Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900",
  },
  {
    label: "Licorice",
    slug: "licorice",
    family: "'Licorice', cursive",
    path: "Licorice",
  },
  {
    label: "Lobster",
    slug: "lobster",
    family: "'Lobster', cursive",
    path: "Lobster",
  },
  {
    label: "Indie Flower",
    slug: "indie-flower",
    family: "'Indie Flower', cursive",
    path: "Indie+Flower",
  },
  {
    label: "Caveat",
    slug: "caveat",
    family: "'Caveat', cursive",
    path: "Caveat:wght@400;700",
  },
  {
    label: "Bebas Neue",
    slug: "bebas-neue",
    family: "'Bebas Neue', cursive",
    path: "Bebas+Neue",
  },
  {
    label: "Varela Round",
    slug: "valera-round",
    family: "'Varela Round', sans-serif",
    path: "Varela+Round",
  },
  {
    label: "Montserrat",
    slug: "montserrat",
    family: "'Montserrat', sans-serif",
    path: "Montserrat:ital,wght@0,100..900;1,100..900",
  },
  {
    label: "Playfair",
    slug: "playfair",
    family: "'Playfair Display', serif",
    path: "Playfair+Display:ital,wght@0,400..900;1,400..900&family=Playfair:ital,opsz,wght@0,5..1200,300..900;1,5..1200,300..900",
  },
  {
    label: "Oswald",
    slug: "oswald",
    family: "'Oswald', sans-serif",
    path: "Oswald:wght@400;700",
  },
  {
    label: "Anton",
    slug: "anton",
    family: "'Anton', sans-serif",
    path: "Anton",
  },
  {
    label: "Fredoka",
    slug: "fredoka",
    family: "'Fredoka One', cursive",
    path: "Fredoka+One",
  },
  {
    label: "Poiret One",
    slug: "poiret-one",
    family: "'Poiret One', cursive",
    path: "Poiret+One",
  },
  {
    label: "Chicle",
    slug: "chicle",
    family: "'Chicle', cursive",
    path: "Chicle",
  },
  {
    label: "Copse",
    slug: "copse",
    family: "'Copse', serif",
    path: "Copse",
  },
  {
    label: "Spectral SC",
    slug: "spectral-sc",
    family: "'Spectral SC', serif",
    path: "Spectral+SC:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,200;1,300;1,400;1,500;1,600;1,700;1,800",
  },
  {
    label: "Pacifico",
    slug: "pacifico",
    family: "'Pacifico', cursive",
    path: "Pacifico",
  },
  {
    label: "Actor",
    slug: "actor",
    family: "'Actor', sans-serif",
    path: "Actor",
  },
  {
    label: "Mitr",
    slug: "mitr",
    family: "'Mitr', sans-serif",
    path: "Mitr:wght@400;700",
  },
  {
    label: "PT Serif",
    slug: "pt-serif",
    family: "'PT Serif', serif",
    path: "PT+Serif:ital,wght@0,400;0,700;1,400;1,700",
  },
  {
    label: "Red Hat Display",
    slug: "red-hat-display",
    family: "'Red Hat Display', sans-serif",
    path: "Red+Hat+Display:ital,wght@0,300..900;1,300..900",
  },
  {
    label: "Work Sans",
    slug: "work-sans",
    family: "'Work Sans', sans-serif",
    path: "Work+Sans:ital,wght@0,100..900;1,100..900",
  },
  {
    label: "Josefin Sans",
    slug: "josefin-sans",
    family: "'Josefin Sans', sans-serif",
    path: "Josefin+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700",
  },
  {
    label: "Acme",
    slug: "acme",
    family: "'Acme', sans-serif",
    path: "Acme",
  },
  {
    label: "Patrick Hand",
    slug: "patrick-hand",
    family: "'Patrick Hand', cursive",
    path: "Patrick+Hand",
  },
  {
    label: "Cormorant Upright",
    slug: "cormorant-upright",
    family: "'Cormorant Upright', serif",
    path: "Cormorant+Upright:wght@400;500;600;700",
  },
  {
    label: "Outfit",
    slug: "outfit",
    family: "'Outfit', sans-serif",
    path: "Outfit:wght@100..900",
  }
];
